import { useState } from "react";

const containerStyle = {
  display: "flex",
  flexGrow: 1
};

const style = {
  flexGrow: 1,
  color: "#202020",
  border: "solid 1px #E0E0E0",
  borderTopLeftRadius: 10,
  borderBottomLeftRadius: 10,
  outline: 0,
  padding: 9,
  fontFamily: "Pretendard",
  fontSize: 16
};

const unitStyle = {
  backgroundColor: "#FFFFFF",
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderTopWidth: 1,
  borderBottomWidth: 1,
  borderColor: "#E0E0E0",
  borderStyle: "solid",
  marginLeft: -1,
  lineHeight: "37px", // why px here
  textAlign: "center",
  fontWeight: 600,
  width: 37,
  MozAppearance: "textfield"
};

const buttonStyle = {
  cursor: "pointer",
  backgroundColor: "#FFFFFF",
  color: "#202020",
  border: "solid 1px #E0E0E0",
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  fontFamily: "Pretendard",
  fontSize: 15,
  fontWeight: 600,
  width: 48,
  height: 39
};

const disabledStyle = {
  cursor: "default",
  backgroundColor: "#E0E0E0",
  color: "#B0B0B0"
};

const unitDisabledStyle = {
  backgroundColor: "#E8E8E8"
};

export function NumberInput(props) {
  const [ value, setValue ] = useState(props.defaultValue || 0);
  const [ disabled, setDisabled ] = useState(true);
  const onChange = (e) => { setValue(e.target.value); setDisabled(false); props.onChange && props.onChange(e); };
  const onClick = (e) => { props.onClick && props.onClick(e, parseFloat(value), setDisabled); };

  return (<>
    <div style={ containerStyle }>
      <input id={ props.id } type="number" style={ style } value={ value } onChange={ onChange } disabled={ props.disabled ?? false }/>
      <span style={ { ...unitStyle, ...(props.disabled && unitDisabledStyle) } }>{ props.unit }</span>
      <button style={ { ...buttonStyle, ...(disabled && disabledStyle) } } onClick={ onClick } disabled={ disabled }>저장</button>
    </div>
  </>);
}
